<div class="create-manifest">
  <div class="header">
    <div class="carrier">
      Delivery Service
      <pdq-icon
        icon="attention"
        matTooltip="Only supported carriers"
        matTooltipClass="pdq-mat-tooltip"
        matTooltipPosition="above"
        size="20"></pdq-icon>
    </div>
    <div>Pickup date</div>
    <div>Inventory location</div>
    <pdq-dropdown
      [options]="carriers"
      [defaultOption]="carriers[0]"
      (onChange)="carrierChanged($event)"
      fullWidth="true"></pdq-dropdown>
    <div class="datepicker">
      @if (selectedCarrier.hasExternalManifest) {
        <input
          matInput
          [matDatepicker]="picker"
          [min]="selectedCarrier.supportPastDays ? startDateOneMonthAgo : startDate"
          [max]="endDate"
          [formControl]="startDateControl" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      } @else {
        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [formControl]="startDateControl" placeholder="Start date" />
          <input matEndDate [formControl]="endDateControl" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      }
      <ng-template #rangePicker>
        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [formControl]="startDateControl" placeholder="Start date" />
          <input matEndDate [formControl]="endDateControl" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker
      ></ng-template>
    </div>
    <pdq-dropdown
      [defaultOption]="locations[0]"
      [options]="locations"
      (onChange)="locationChanged($event)"
      fullWidth="true"></pdq-dropdown>
  </div>
  <div class="table-wrapper">
    <app-table
      [table]="TABLES.ORDERS_TO_MANIFEST"
      [rows]="temp"
      [displayPickList]="true"
      [columnsSettings]="columns"
      [rowsLoading]="loading"
      [focusedRowId]="focusedOrderId"
      [totalCountOrders]="totalCountOrders"
      [perPageActiveOption]="ordersPerPage"
      [allPages]="allPages"
      [activePage]="activePage"
      [totalPages]="totalPages"
      [selected]="selected"
      [message]="chooseEmptyMessage()"
      (sort)="sortColumns($event)"
      (changeFilter)="onChangeTableFilter($event)"
      (changeSelectedOrders)="onSelect($event)"
      (changePerPage)="onChangeOrdersPerPage($event)"
      (changePage)="paginate($event)"
      (jumpToPage)="jumpToPage($event)"
      (onBottomScrolled)="onBottomScrolled($event)"
      (onDrawerLoading)="onDrawerLoading($event)"
      [emptyMessage]="emptyMessage"></app-table>
  </div>
  <div class="footer">
    @if (selected.length) {
      <div class="selected-text">{{ selected.length }} orders selected</div>
    }
    <pdq-button
      [disabled]="!selected.length || loading"
      variant="primary"
      label="Create manifest"
      (onClick)="createManifest()"
      [loading]="loadingCreate"></pdq-button>
  </div>
</div>
